import React, {useEffect, useState, useRef} from 'react'
import {Header} from '../Header'
import {LogoutPopup} from '../LogoutPopup'
import {IngresoPromocionHeader} from './IngresoPromocionHeader'
import {LengendColumns} from './LengendColumns'
import {LengendColumnsInput} from './LengendColumnsInput'
import '../../assets/css/IngresoPromocion.css'
import '@splidejs/react-splide/css'
import {LegendColumnRight} from './LegendColumnRight'
import {getPromotion} from '../../services/promotion.service'
import {getAllProducts} from '../../services/products.service'
import {getPreviousSimulation, simulatePromotion} from '../../services/simulation.service'
import {savePromotion, changeStateMultipleRows} from '../../services/save.service'
import {deleteRow} from '../../services/delete.service'
import {Promotion} from '../../utils/PromotionInit'
import { useParams} from 'react-router-dom'
import {InicioPopEliminar} from './InicioPopEliminar'
import {InicioPopValidacion} from './InicioPopValidacion'
import { descuentoaNumero, dineroaNumero, numeroaDescuento, numeroaDinero} from './helper'
import {Simulacion} from './Simulacion'
import {Spinner} from '../../componentsRef/ui'
import './input.css'
import { CSVLink } from 'react-csv';
import { CargaMasiva } from './CargaMasiva'
import { LoaderNew } from '../../components/LoaderNew'
import { CodigoPopNew } from './CodigoPopNew'
import { SetFechas } from './SetFechas'
import { SetMecanica } from './SetMecanica'
import { SetCampoMasivo } from './SetCampoMasivo'
import { RechazoProductoModal } from './RechazoProductoModal'

function leftJoin(data, products, keyName, keyName2) {
	return data.map(item => {
	  const product = products.find(p => p[keyName] === item[keyName2]);
	  return { ...item, ...product };
	});
  }

function calcularPrecioPromocionFallback(product) {
	const hasPrecioPromocion =
		product.precio_promocion !== null &&
		product.precio_promocion !== undefined &&
		String(product.precio_promocion).trim() !== '';

	if (hasPrecioPromocion) {
		return product.precio_promocion;
	}

	const precioLista = parseFloat(product.precio_lista);
	const descuento = parseFloat(product.descuento);

	if (!isFinite(precioLista) || !isFinite(descuento)) {
		return product.precio_promocion;
	}

	if (String(product.tipo_promocion).toUpperCase() === 'SELL-IN') {
		return Math.round(precioLista * (1 - descuento / 100));
	}

	const mgCliente = parseFloat(product.margen_cliente);
	if (!isFinite(mgCliente)) {
		return product.precio_promocion;
	}

	const denominator = 1 - mgCliente / 100;
	if (denominator === 0) {
		return product.precio_promocion;
	}

	if (String(product.um).toUpperCase() === 'KG') {
		const factor = parseFloat(product.factor);
		if (!isFinite(factor)) {
			return product.precio_promocion;
		}
		return Math.round((precioLista * factor * 1.19) / denominator);
	}

	return Math.round((precioLista * 1.19) / denominator);
}

export const IngresoPromocion = () => {
	const [LogoutState, setLogoutState] = useState(false)
	const [HeightState, setHeight] = useState(0)
	const [HeightStateRight, setHeighRight] = useState(0)
	const [TransformState, setTransformState] = useState(0)
	const [legendColumns, setLegendColumns] = useState([]);
	const [promotion, setPromotion] = useState(null);
	const { idPromocion } = useParams()
	const { estadoPromocion } = useParams()
	const [idProductoEliminar, setIdProductoEliminar] = useState(null)
	const [products, setProducts] = useState(null)
	const [dataRows, setDataRows] = useState(null)
	const [isInitialized, setIsInitialized] = useState(false)
	const [accionGuardar, setAccionGuardar] = useState(false)
	const [InicioPopState, setInicioPopState] = useState(null)
	const [idEliminar, setIdEliminar] = useState(null)
	const [validacion, setValidacion] = useState(null)
	const [textoValidacion, setTextoValidacion] = useState([])
	const [aprobarMovimiento, setAprobarMovimiento] = useState(false);
	const urlParams = new URLSearchParams(window.location.search);
  	const viewPage = urlParams.get('v');
	const [simulacionPage, setSimulacionPage] = useState(false);
	const [simulacionProcess, setSimulacionProcess] = useState(false);
	const [simulacionData, setSimulacionData] = useState(null);
	const [validacionProcess, setValidacionProcess] = useState(false);
	const [dataDescarga, setDataDescarga] = useState([]);
	const [flagReloadPromotion, setFlagReloadPromotion] = useState(true);
	const [typePromotion, setTypePromotion] = useState(null);
	const [cargaMasiva, setCargaMasiva] = useState(false);
	const [loader, setLoader] = useState(false)
	const [dataProduct, setDataProduct] = useState(null)
	const [modalProduct, setModalProduct] = useState(false)
	const [rejectReasonProduct, setRejectReasonProduct] = useState(null)
	const [fechasCambiar, setFechasCambiar] = useState(false)
	const [inicioCambio, setInicioCambio] = useState(null)
	const [terminoCambio, setTerminoCambio] = useState(null)
	const [accionCambiarFecha, setAccionCambiarFecha] = useState(false)
	const [tipoBotonPromotion, setTipoBotonPromotion] = useState(null)
	const [mecanicaCambiar, setMecanicaCambiar] = useState(false)
	const [valorMecanicaCambio, setValorMecanicaCambio] = useState(null)
	const [accionCambiarMecanica, setAccionCambiarMecanica] = useState(false)
	const [tipoBotonMecanica, setTipoBotonMecanica] = useState(null)
	const [campoMasivoCambiar, setCampoMasivoCambiar] = useState(false)
	const [valorCampoMasivo, setValorCampoMasivo] = useState(null)
	const [accionCambiarCampoMasivo, setAccionCambiarCampoMasivo] = useState(false)
	const [tipoBotonCampoMasivo, setTipoBotonCampoMasivo] = useState(null)
	const [campoMasivoTipo, setCampoMasivoTipo] = useState(null)
	const [previousSimulation, setPreviousSimulation] = useState(true)
	const [changeColumn, setChangeColumn] = useState(null)
	const [catalogViewMode, setCatalogViewMode] = useState('columns')
	const csvLinkRef = useRef(null);
	// alert(viewPage);

	const HandleResizeWork = () => {
		const WindowHeight = window.innerHeight - 130
		const WindowHeightRight = window.innerHeight - 103
		setHeight(WindowHeight)
		setHeighRight(WindowHeightRight)
	}
	const toggleSimulacionPage = (page) => {
		// Cambiar la ubicación en el historial de navegación
		const url = new URL(window.location.href);
		if (page) {
			url.searchParams.set('simulacion', 'true');
		} else {
			url.searchParams.delete('simulacion');
		}
		window.history.pushState(null, '', url.toString());
		// setSimulacionPage(!simulacionPage);
	  };

	useEffect(() => {
		setLoader(true)
		localStorage.setItem("gestionProductos", []);
		setTimeout(() => {
			setLoader(false)
		}	, 5000)
	}, [])
		

	useEffect(() => {
		const handlePopstate = (event) => {
		  if (simulacionPage) {
			setSimulacionPage(false);
			// setcurrentOption(null);
		  } else {
			history.back(); // Permite al navegador manejar el comportamiento por defecto del botón "Atrás"
		  }
		};
	
		window.addEventListener('popstate', handlePopstate);
	
		return () => {
		  window.removeEventListener('popstate', handlePopstate);
		};
	  }, [simulacionPage]);

	useEffect(() => {
		window.addEventListener('resize', HandleResizeWork)
		HandleResizeWork()
	}, [])

	// Actualización de campos (cualquiera de los campos) por cada edición de inputs sobre legendcolumns:::
	useEffect(() => {
		if (changeColumn) {
				
		  const { id, updates } = changeColumn;
		  // alert(updates.id)
		  // alert(updates.mecanica)
		  setLegendColumns((prevLegendColumns) => {
				if (!Array.isArray(prevLegendColumns)) return [];
  
				return prevLegendColumns.map((column) => {
				  // Solo modifica la columna que coincida con el ID
				  if (column.props.id !== id) return column;
				  console.log(updates)
				  return {
						...column,
						props: {
						  ...column.props,
						  ...updates,
						},
				  };
				});
		  });
  
		  // Opcional: limpiar el cambio después de aplicarlo
		  setChangeColumn(null);
		}
  }, [changeColumn]);
  

	// Eliminar producto
	useEffect(() => {
		console.log("legendColumns::::: index!!!");
		console.log(legendColumns);
		if(legendColumns && idProductoEliminar){
			/*
			console.log("eliminarProducto", id)
			
			const ColumnInput = document.getElementById("ColumnInput_"+id)
			console.log("ColumnInput", ColumnInput)
			ColumnInput.remove()
			*/
		console.log("Estado actual:::. ");
		console.log(legendColumns)
		
		legendColumns.forEach((component) => {
			console.log("Componente actual:::....::. ");
			console.log(component.props.key+" id promocion promociones ");
			})
		
		const filteredColumns = legendColumns.filter(
				component => component.props.id !== idProductoEliminar.split("_")[0] +"_"+idProductoEliminar.split("_")[1]
		);

		const componentToDelete = legendColumns.filter(
			component => component.props.id === idProductoEliminar.split("_")[0] +"_"+idProductoEliminar.split("_")[1]
		);

		console.log("Columnas NO ELIMINADAS AL FINAL:::.");
		console.log(filteredColumns);
		// setLegendColumns(filteredColumns); // se cambia por una función useEFFECT de retorno
		setLegendColumns((prevLegendColumns) => {
			const filteredColumns = prevLegendColumns.filter(
			  (component) => component.props.id !== idProductoEliminar.split("_")[0] +"_"+idProductoEliminar.split("_")[1]
			);
			return filteredColumns;
		  });
		/*
		const newPromotion = {...promotion};
		newPromotion.data_rows = newPromotion.data_rows.filter((row) => {
			return row.cod_producto !== getId(componentToDelete[0].props.id.split("_")[0], "codigo_producto");
		});
		setPromotion(newPromotion);
		*/
		// El id está compuesto del código de cliente y la cadena separado por _
		let codProducto = idProductoEliminar.split("_")[2]// getId(componentToDelete[0].props.id.split("_")[0], "codigo_producto");
		if(codProducto === -1){ // Esto queda deprecado...
			codProducto = componentToDelete[0].props.id.split("_")[0];
		}

		codProducto = componentToDelete[0].props.id.split("_")[0];
		/*
		setPromotion((prevPromotion) => {
			const newPromotion = {...prevPromotion};
			newPromotion.data_rows = newPromotion.data_rows.filter((row) => {
				return row.cod_producto !== getId(componentToDelete[0].props.id.split("_")[0], "codigo_producto");
			});
			return newPromotion;
		});
		*/
		let idFila = -1;
		promotion.data_rows.forEach((row, index) => {
			if(row.cod_producto === codProducto){
				idFila = row.id;
			}
		});
		setIdProductoEliminar(null)
		console.log("A eliminar:::::::::::: ");
		console.log(componentToDelete[0].props.keyId);
		console.log("ID REal a eliminar:::: "+idFila);

		try{
			console.log("ID A ELIMINAR DE TABLA::: "+componentToDelete[0].props.keyId);
			console.log("ID REAL A ELIMINAR:::: "+componentToDelete[0].props.keyId)
				// if(componentToDelete[0].props.keyId !== null && componentToDelete[0].props.keyId !== undefined){
					deleteRow(componentToDelete[0].props.keyId).then((response) => {
						console.log("Respuesta de guardado de promocion::: ");
						console.log(response);
						});
				// }
			}catch(error){
				console.log("Error al intentar eliminar........");
				console.log(error);
				console.log("El producto no existe en la BD, es nuevo");
			}
			
		// set Flag para reinicializar todo
		}
		setFlagReloadPromotion(true);
		setPreviousSimulation(true);
	}, [legendColumns, idProductoEliminar])
	// Obtener la promoción
	useEffect(() => {
		;(async () => {
			try {
				// setLoading(true)
				
				const {data} = await getPromotion(idPromocion, estadoPromocion)
				if (data) {
					console.log("Promocion DATA Origin!!!::::: ");
					console.log(data);
					if(typePromotion === null){
						setTypePromotion(data.data_promocion.tipo_promocion);
						// setPromotion(data)
					}else{
						data.data_promocion.tipo_promocion = typePromotion;
						// setPromotion(data)
					} 
					setPromotion(data)
					console.log("Promocion DATA!!!::::: ");
					console.log(data);
					// setLoading(false)
				}
				
			} catch (error) {
				setPromotion(Promotion)
				console.log(error)
				// setLoading(false)
			} finally {
				// setLoading(false)
			}
			setFlagReloadPromotion(false);
			
		})()
	}, [flagReloadPromotion]);
	// Actualizar la promoción con el tipo para mostrar: SELL-IN o SELL-OUT
	useEffect(() => {
		if(promotion && typePromotion){
			const newPromotion = {...promotion};
			newPromotion.data_promocion.tipo_promocion = typePromotion; // SELL-IN o SELL-OUT
			setPromotion(newPromotion);
		}
	}, [typePromotion]);
	// Obtener todos los productos
	useEffect(() => {
		;(async () => {
			try {
				// setLoading(true)
				if(promotion){
					const {data} = await getAllProducts(promotion.data_promocion.nombre_cadena, idPromocion)
					if (data) {
						setProducts(data)
						console.log("Products DATA!!!::::: ");
						console.log(data);
						// setLoading(false)
					}
				}
				
			} catch (error) {
				// setPromotion(Promotion)
				console.log(error)
				// setLoading(false)
			} finally {
				// setLoading(false)
			}
		})()
	}, [promotion]);

	// Obtener Simulación Previa
	useEffect(() => {
		if(previousSimulation){
			;(async () => {
				try {
					// setLoading(true)
					const {data} = await getPreviousSimulation(idPromocion, estadoPromocion)
					
					if (data) {
						data.resultado_simulacion.forEach((item, index) => {
							// item.margen_incremental_pct = item.margen_incremental_;
							item.margen_incremental_dinero = item.margen_promocion;

						})
						setSimulacionData(data)
						console.log("simulacion final lista DATA!!!::::: ");
						console.log(data);
						// console.log(simulacionData);
						// setLoading(false)
					}else{
						setSimulacionData(
							{
								"data_promocion": {
									"baseline": "-",
									"uplift": "-",
									"roi": "-",
									"margen_incremental": "-"
								}
							}
						)
					}
				} catch (error) {
					// setPromotion(Promotion)
					console.log("ERROR SIMULACION SET DATA");
					console.log(error)
					setSimulacionData(
						{
							"data_promocion": {
								"baseline": "-",
								"uplift": "-",
								"roi": "-",
								"margen_incremental": "-"
							}
						}
					)
					// setLoading(false)
				} finally {
					// setLoading(false)
					setPreviousSimulation(false);
				}
			})()
		}
	}, [previousSimulation]);
	// Intersección de productos y promociones
	useEffect(() => {
		if(promotion && products){
			const result = leftJoin(promotion.data_rows, products, "id_producto", "cod_producto");
			setDataRows(result);
			console.log("DATA ROWS NUEVO!!!!");
			console.log(result);
		}
	}, [promotion, products])
	// Sincronizar IDs de filas (keyId) luego de recargar promoción/guardar/simular
	useEffect(() => {
		if (!Array.isArray(dataRows) || !Array.isArray(legendColumns) || !promotion) return;

		const keyIdByCompId = new Map();
		dataRows.forEach((row) => {
			const codigo = row.codigo_producto;
			if (codigo === undefined || codigo === null) return;
			const compId = `${codigo}_${promotion.data_promocion.nombre_cadena}`;
			if (row.id !== undefined && row.id !== null) {
				keyIdByCompId.set(compId, row.id);
			}
		});

		if (keyIdByCompId.size === 0) return;

		setLegendColumns((prevLegendColumns) => {
			if (!Array.isArray(prevLegendColumns)) return prevLegendColumns;
			let changed = false;
			const next = prevLegendColumns.map((column) => {
				const newKeyId = keyIdByCompId.get(column.props.id);
				if (newKeyId && column.props.keyId !== newKeyId) {
					changed = true;
					return {
						...column,
						props: {
							...column.props,
							keyId: newKeyId,
						},
					};
				}
				return column;
			});
			return changed ? next : prevLegendColumns;
		});
	}, [dataRows, legendColumns, promotion]);
	// Inicio carga de columnas
	useEffect(() => {
		// Este efecto se ejecutará cada vez que 'dataRows' cambie
		console.log("DATA ROWS NUEVO ORIGINAL ..!!!!");
		console.log(dataRows);
		// Desplegar los productos en la columna central::: 

			const componentColumns = [];
			if(Array.isArray(dataRows) && !isInitialized){
				dataRows.forEach((product) => {
					const precioPromocionCalculado = calcularPrecioPromocionFallback(product);
					const pvpCalculado = (() => {
						const hasPvp = product.pvp !== null && product.pvp !== undefined && String(product.pvp).trim() !== '';
						const hasMargen = product.margen_cliente !== null && product.margen_cliente !== undefined && String(product.margen_cliente).trim() !== '';
						if (hasPvp || !hasMargen) return product.pvp;

						const precioPromocion = parseFloat(precioPromocionCalculado);
						const mgCliente = parseFloat(product.margen_cliente);
						if (!isFinite(precioPromocion) || !isFinite(mgCliente)) return product.pvp;

					const denom = 1 - (mgCliente / 100);
					if (denom === 0) return product.pvp;

					if (String(product.um).toUpperCase() === 'KG') {
						const factor = parseFloat(product.factor);
						if (!isFinite(factor)) return product.pvp;
						return Math.round((precioPromocion * factor * 1.19) / denom);
					}
					return Math.round((precioPromocion * 1.19) / denom);
				})();

				componentColumns.push(
					<LengendColumnsInput 
					key={product.codigo_producto+"_"+promotion.data_promocion.nombre_cadena}
					keyId={product.id} 
					id={product.codigo_producto+"_"+promotion.data_promocion.nombre_cadena} 
					legendColumns={legendColumns} 
					setLegendColumns={setLegendColumns}
						promotion={promotion}
						codigoProducto={product.codigo_producto}
						descripcion={product.descripcion}
						precioLista={product.precio_lista}
						precioPromocion={precioPromocionCalculado}
						descuento={product.descuento}
					mecanica={product.mecanica}
					adherencia={product.adherencia}
					exhibicion={product.id_exhibicion}
					activacion={product.activacion}
					invAdicional={product.inversion_adicional}
					mgCliente={product.margen_cliente} // Solo se lee.
					pvp={pvpCalculado} // Solo se lee
					inicioSellin={product.inicio_sellin}
					terminoSellin={product.termino_sellin}
					inicioSellout={product.inicio_sellout}
					terminoSellout={product.termino_sellout}
					setIdProductoEliminar={setIdProductoEliminar}
					tipoPromocion={product.tipo_promocion} // Este tipoPromocion se debe cambiar
					setInicioPopState={setInicioPopState}
					setIdEliminar={setIdEliminar}
					idProducto={product.id_producto}
					product={product}
					setModalProduct={setModalProduct}
					setDataProduct={setDataProduct}
					setRejectReasonProduct={setRejectReasonProduct}
					setChangeColumn={setChangeColumn}
					/>
				);
			});
			// Agregar un nuevo componente <LengendColumnsInput/> con el ID 5000 a la lista
			/* <LengendColumnsInput key={1000} id={1000} 
				legendColumns={legendColumns} 
				setLegendColumns={setLegendColumns}
				promotion={promotion}
				/> */
				setLegendColumns(prevLegendColumns => {
					if (Array.isArray(prevLegendColumns)) {
					  return [...prevLegendColumns, ...componentColumns];
					} else {
					  // En caso de que prevLegendColumns no sea un array inicialmente, puedes manejarlo como desees.
					  // Por ejemplo, aquí estamos devolviendo un array solo con componentColumns en caso de que no sea un array.
					  return [...componentColumns];
					}
				  });
			setIsInitialized(true); // Para que no se vuelva a ejecutar este efecto.
			setValidacionProcess(true); // Para validar los campos al inicio.
		}
	}, [isInitialized, dataRows]);

	// funciones para formatear data antes de guardar
	
	const getId = (valor, tipo) => {
		let id;
		console.log("GET ID.:::: "+tipo);
		switch (tipo) {
			case "activacion":
				try{
					id = promotion.activaciones.find((activacion) => activacion.activacion.replace(/\s/g, '').toUpperCase() === valor.replace(/\s/g, '').toUpperCase()).id;
					return id;
				}catch(error){
					return -1;
				}				
			case "exhibicion":
				// alert(valor);
				try{
					id = promotion.exhibiciones.find((exhibicion) => exhibicion.exhibicion.replace(/\s/g, '').toUpperCase() === valor.replace(/\s/g, '').toUpperCase()).id;
					// alert("ID exhibicion "+id);
					return id;
				}catch(error){
					return -1;
				}
			case "mecanica":
				try{
					id = promotion.mecanicas.find((mecanica) => mecanica.mecanica.replace(/\s/g, '').toUpperCase() === valor.replace(/\s/g, '').toUpperCase()).id;
					// alert("ID mecanica "+id);
					return id;
				}catch(error){
					return -1;
				}
			case "codigo_producto":
				try{
					id = products.find((product) => product.codigo_producto.replace(/\s/g, '').toUpperCase() === valor.replace(/\s/g, '').toUpperCase()).id_producto;
					// alert("ID producto "+id);
					return id;
				}catch(error){
					return -1;
				}
			case "activacionValue":
				try{
					id = promotion.activaciones.find((activacion) => activacion.id === valor).activacion;
					return id;
				}catch(error){
					return -1;
				}
			case "exhibicionValue":
					try{
						id = promotion.exhibiciones.find((exhibicion) => exhibicion.id === valor).exhibicion;
						return id;
					}catch(error){
						return -1;
					}
			case "mecanicaValue":
				try{
					id = promotion.mecanicas.find((mecanica) => String(mecanica.id).replace(/\s/g, '').toUpperCase() === String(valor).replace(/\s/g, '').toUpperCase()).mecanica;
					return id;
				}catch(error){
					return -1;
				}
			case "codigo_productoValue":
					try{
						// alert(product.id_producto.replace(/\s/g, '').toUpperCase()+" === "+valor.replace(/\s/g, '').toUpperCase());
						id = products.find((product) => String(product.id_producto).replace(/\s/g, '').toUpperCase() === String(valor).replace(/\s/g, '').toUpperCase()).codigo_producto;
						// alert("ID producto "+id);
						return id;
					}catch(error){
						console.log("ERROR CODIGO PRODUCTO VALUE ::. "+error);
						return -1;
					}
		}
		return 1;
	}

	const getDateFormat = (date) => {
		return date.split("-").reverse().join("/");
	} 

	const getCorrectDate = (date) => {
		return date.split("/").reverse().join("-");
	}

	const buildPromotionPayloadFromColumns = () => {
		const newColumns = []
		const now = new Date();
		legendColumns.forEach((component) => {
			let inicioSellin = '';
			let terminoSellin = '';
			let inicioSellout = '';
			let terminoSellout = '';

			if(component.props.tipoPromocion === 'SELL-IN'){
				inicioSellin = getCorrectDate(document.getElementById("inicio_"+component.props.id+"_sellin").value)
				inicioSellout = getCorrectDate(document.getElementById("inicio_"+component.props.id+"_sellout").value)
				terminoSellin = getCorrectDate(document.getElementById("termino_"+component.props.id+"_sellin").value)
				terminoSellout= getCorrectDate(document.getElementById("termino_"+component.props.id+"_sellout").value)
			}else{
				inicioSellin = getCorrectDate(document.getElementById("inicio_"+component.props.id+"_sellout").value)
				inicioSellout = getCorrectDate(document.getElementById("inicio_"+component.props.id+"_sellout").value)
				terminoSellin = getCorrectDate(document.getElementById("termino_"+component.props.id+"_sellout").value)
				terminoSellout= getCorrectDate(document.getElementById("termino_"+component.props.id+"_sellout").value)
			}

			newColumns.push({
				codigo_producto : component.props.codigoProducto,
				activacion: getId(document.getElementById("activacion_"+component.props.id).value, "activacion"),
				adherencia: descuentoaNumero(document.getElementById("adherencia_"+component.props.id).value),
				id_producto: component.props.product.id_producto,
				descripcion : component.props.descripcion,
				descuento: descuentoaNumero(document.getElementById("descuento_"+component.props.id).value),
				fecha_actualizacion: now.toISOString().slice(0, 10)+" "+now.toISOString().slice(11, 19),
				inicio_sellin: inicioSellin,
				inicio_sellout: inicioSellout,
				inversion_adicional: dineroaNumero(document.getElementById("invadicional_"+component.props.id).value),
				margen_cliente: descuentoaNumero(document.getElementById("mgcliente_"+component.props.id).value),
				mecanica: getId(document.getElementById("mecanica_"+component.props.id).value, "mecanica"),
				nombre_promo: promotion.data_promocion.nombre_promocion,
				precio_lista: component.props.precioLista,
				precio_promocion: dineroaNumero(document.getElementById("preciopromocion_"+component.props.id).value),
				promotora: 2,
				publicacion: 5,
				pvp: dineroaNumero(document.getElementById("pvp_"+component.props.id).value),
				duracion_sellin: 1,
				duracion_sellout: 1,
				termino_sellin: terminoSellin,
				termino_sellout: terminoSellout,
				exhibicion: getId(document.getElementById("exhibicion_"+component.props.id).value, "exhibicion"),
				tipo_promocion : component.props.tipoPromocion,
				id_estado_promocional: !component.props.estadoPromocional ? estadoPromocion : component.props.estadoPromocional,
				estado_promocional: !component.props.estadoPromocional ? estadoPromocion : component.props.estadoPromocional
			});
		});

		const newPromotion = {...promotion};
		newPromotion.data_rows = newColumns.filter((row) => {
			if(row) return row.cod_producto !== -1 && typeof row.cod_producto !== 'string';
			return false
		});
		return newPromotion;
	}

	const saveCatalogBeforeProductComment = () => {
		const catalogPayload = buildPromotionPayloadFromColumns();
		return savePromotion(idPromocion, catalogPayload);
	}

	const hasAdherenciaMayorA100 = (promotionData) => {
		if (!promotionData || !Array.isArray(promotionData.data_rows)) return false;
		return promotionData.data_rows.some((row) => Number(row?.adherencia) > 100);
	}

	const getProductDecisionConfig = () => {
		const rol = localStorage.getItem('rol')
		const isReviewState = estadoPromocion === '5' || estadoPromocion === '7'
		const isNegotiationState = estadoPromocion === '9'
		const canUseDecisionActions = !viewPage && (
			(isReviewState && (rol === 'ADMIN' || rol === 'SUPER ADMIN' || rol === 'APROBADOR')) ||
			(isNegotiationState && (rol === 'ADMIN' || rol === 'SUPER ADMIN' || rol === 'KAM' || rol === 'KAS'))
		)

		return {
			canUseDecisionActions,
			rejectLabel: isNegotiationState ? 'Sin Acuerdo' : 'Rechazar',
		}
	}

	const getStoredProductDecisions = () => {
		try {
			const storedDecisions = localStorage.getItem('gestionProductos')
			return storedDecisions ? JSON.parse(storedDecisions) : []
		} catch (error) {
			console.log('Error leyendo gestionProductos::: ')
			console.log(error)
			return []
		}
	}

	const getProductIdFromColumn = (column) => column?.props?.product?.id_producto || column?.props?.idProducto

	const isProductAlreadyDecided = (column, storedDecision) => {
		if (storedDecision) return true

		const product = column?.props?.product || {}
		const currentState = Number(
			product.id_estado_promocional ??
			product.estado_promocional ??
			column?.props?.estadoPromocional
		)

		return currentState === 7 || currentState === 8
	}

	const handleBulkProductDecision = (decision) => {
		const {canUseDecisionActions} = getProductDecisionConfig()
		if (!canUseDecisionActions || !Array.isArray(legendColumns)) return

		const storedDecisions = getStoredProductDecisions()
		const nextDecisions = [...storedDecisions]
		const decidedProductIds = new Set(
			storedDecisions.map((item) => Number(item.id_producto))
		)
		let hasChanges = false

		legendColumns.forEach((column) => {
			if (column?.props?.tipoPromocion !== typePromotion) return

			const productId = getProductIdFromColumn(column)
			if (!productId) return

			const storedDecision = storedDecisions.find(
				(item) => Number(item.id_producto) === Number(productId)
			)

			if (isProductAlreadyDecided(column, storedDecision)) return

			if (column.props.product) {
				column.props.product.estado_promocional = decision === 'aprobado' ? 8 : 7
				column.props.product.id_estado_promocional = decision === 'aprobado' ? 8 : 7
			}

			if (!decidedProductIds.has(Number(productId))) {
				nextDecisions.push({
					id_promocion: idPromocion,
					id_producto: productId,
					accion: decision,
				})
				decidedProductIds.add(Number(productId))
				hasChanges = true
			}
		})

		if (!hasChanges) return

		localStorage.setItem('gestionProductos', JSON.stringify(nextDecisions))
		window.dispatchEvent(new Event('storage'))
		setLegendColumns((prevLegendColumns) => [...prevLegendColumns])
	}

	const getTableHeaders = () => {
		const promotionTypeKey = typePromotion === 'SELL-IN' ? 'sell_in' : 'sell_out'
		const openFieldMassEdit = (field) => {
			setTipoBotonCampoMasivo(promotionTypeKey)
			setCampoMasivoTipo(field)
			setCampoMasivoCambiar(true)
		}

		const baseHeaders = [
			{label: 'Acciones'},
			{label: 'Código'},
			{label: 'Descripción'},
			{label: 'Precio Lista'},
			{
				label: typePromotion === 'SELL-IN' ? 'Precio Promoción' : 'PVP Fleje',
				onClick: () => openFieldMassEdit('precioPromocion'),
			},
			{label: '% Descuento', onClick: () => openFieldMassEdit('descuento')},
			{
				label: 'Mecánica',
				onClick: () => {
					setTipoBotonMecanica(promotionTypeKey)
					setMecanicaCambiar(true)
				},
			},
			{label: 'Adherencia', onClick: () => openFieldMassEdit('adherencia')},
			{label: 'Exhibición', onClick: () => openFieldMassEdit('exhibicion')},
			{label: 'Activación', onClick: () => openFieldMassEdit('activacion')},
			{label: 'Inv. Adicional', onClick: () => openFieldMassEdit('invAdicional')},
			{label: 'Margen Cliente', onClick: () => openFieldMassEdit('mgCliente')},
			{label: 'PVP Promoción'},
			{label: 'ROI'},
			{label: 'Uplift (%)'},
			{label: 'Uplift (Und.)'},
			{label: 'Mg. Promocional'},
		]

		if (typePromotion === 'SELL-IN') {
			return [
				...baseHeaders,
				{
					label: 'Sell-In',
					onClick: () => {
						setTipoBotonPromotion('sell_in')
						setFechasCambiar(true)
					},
				},
				{
					label: 'Sell-Out',
					onClick: () => {
						setTipoBotonPromotion('sell_out')
						setFechasCambiar(true)
					},
				},
			]
		}

		return [
			...baseHeaders,
			{
				label: 'Sell-Out',
				onClick: () => {
					setTipoBotonPromotion('sell_out')
					setFechasCambiar(true)
				},
			},
		]
	}

	const formatTableMetric = (value, {prefix = '', suffix = ''} = {}) => {
		if (value === null || value === undefined || value === '') return '-'
		const normalized = String(value).trim()
		if (!normalized || normalized === '-') return '-'
		const withoutTrailingPercent = normalized.replace(/%$/, '')
		const withPrefix = prefix && !withoutTrailingPercent.startsWith(prefix)
			? `${prefix}${withoutTrailingPercent}`
			: withoutTrailingPercent
		return suffix && !withPrefix.endsWith(suffix) ? `${withPrefix}${suffix}` : withPrefix
	}

	const getMetricStatusFromRoi = (value) => {
		const roi = parseFloat(String(value ?? '').replace('%', '').replace(',', '.'))
		if (!isFinite(roi)) return 'neutral'
		return roi >= 1 ? 'positive' : 'negative'
	}

	const getSimulationMetricsForProduct = (product) => {
		const simulationRows = simulacionData?.resultado_simulacion || []
		const simulationProduct = simulationRows.find((item) => {
			return (
				Number(item?.id_producto) === Number(product?.id_producto) ||
				String(item?.sku) === String(product?.codigo_producto) ||
				String(item?.codigo_producto) === String(product?.codigo_producto)
			)
		})
		const metricSource = simulationProduct || product || {}
		const roi = formatTableMetric(metricSource.roi)

		return {
			roi,
			upliftPercent: formatTableMetric(
				metricSource.uplift_porcentual ??
				metricSource.uplift_porcentaje ??
				metricSource.uplift_pct,
				{suffix: '%'}
			),
			upliftUnits: formatTableMetric(metricSource.uplift),
			promotionalMargin: formatTableMetric(
				metricSource.margen_comercial ??
				metricSource.margen_promocional ??
				metricSource.margen_promocion ??
				metricSource.mg_promocional,
				{prefix: '$'}
			),
			status: getMetricStatusFromRoi(roi),
		}
	}

	const renderLegendColumnComponent = (component, index) => {
		const isVisible = component?.props?.tipoPromocion === typePromotion
		const tableMetrics = getSimulationMetricsForProduct(component?.props?.product)
		const shouldCloneComponent = viewPage || catalogViewMode === 'table'
		const renderedComponent = shouldCloneComponent
			? React.cloneElement(component, {
					view: viewPage ? true : component?.props?.view,
					tableMetrics,
					isTableView: catalogViewMode === 'table',
					key: index,
				})
			: component

		return (
			<div
				key={`${component?.props?.id || 'column'}-${index}`}
				className='promotion-table-row'
				style={{display: isVisible ? (catalogViewMode === 'table' ? 'block' : 'block') : 'none'}}
			>
				{renderedComponent}
			</div>
		)
	}

	// Guardar cambios definitivos
	useEffect(() => {
		if(accionGuardar || simulacionProcess || validacionProcess){
			console.log("Guardando cambios!!!!!!!!!");
			// Capturar los datos de cada columna desde los ID's en base a las 
			const newColumns = []
			const now = new Date();
			legendColumns.forEach((component) => {
				// alert(component.props.id);
				let inicioSellin = '';
				let terminoSellin = '';
				let inicioSellout = '';
				let terminoSellout = '';
				console.log("Tipo Promocion de la fila:::: "+component.props.tipoPromocion)
				if(component.props.tipoPromocion === 'SELL-IN'){
			
					inicioSellin = getCorrectDate(document.getElementById("inicio_"+component.props.id+"_sellin").value)
					inicioSellout = getCorrectDate(document.getElementById("inicio_"+component.props.id+"_sellout").value)
					terminoSellin = getCorrectDate(document.getElementById("termino_"+component.props.id+"_sellin").value)
					terminoSellout= getCorrectDate(document.getElementById("termino_"+component.props.id+"_sellout").value)					
					
				}else{
					inicioSellin = getCorrectDate(document.getElementById("inicio_"+component.props.id+"_sellout").value)
					inicioSellout = getCorrectDate(document.getElementById("inicio_"+component.props.id+"_sellout").value)
					terminoSellin = getCorrectDate(document.getElementById("termino_"+component.props.id+"_sellout").value)
					terminoSellout= getCorrectDate(document.getElementById("termino_"+component.props.id+"_sellout").value)
				}
				
					const newColumn = {

						codigo_producto : component.props.codigoProducto,
						// id_compuesto: component.props.id,
						activacion: getId(document.getElementById("activacion_"+component.props.id).value, "activacion"),
						adherencia: descuentoaNumero(document.getElementById("adherencia_"+component.props.id).value),
						// cod_producto: getId(component.props.id.split("_")[0], "codigo_producto"),
						id_producto: component.props.product.id_producto, // getId(component.props.id.split("_")[0], "codigo_producto"),
						descripcion : component.props.descripcion,
						// descripcion_producto: component.props.descripcion,
						descuento: descuentoaNumero(document.getElementById("descuento_"+component.props.id).value),
						fecha_actualizacion: now.toISOString().slice(0, 10)+" "+now.toISOString().slice(11, 19),
						// id_activacion: getId(document.getElementById("activacion_"+component.props.id).value, "activacion"),
						// id_exhibicion: getId(document.getElementById("exhibicion_"+component.props.id).value, "exhibicion"),
						// id_mecanica: getId(document.getElementById("mecanica_"+component.props.id).value, "mecanica"),
						// id_promotora: 2,
						// id_publicacion: 5,
	
						inicio_sellin: inicioSellin,
						inicio_sellout: inicioSellout,
						inversion_adicional: dineroaNumero(document.getElementById("invadicional_"+component.props.id).value),
						margen_cliente: descuentoaNumero(document.getElementById("mgcliente_"+component.props.id).value),
						mecanica: getId(document.getElementById("mecanica_"+component.props.id).value, "mecanica"),
						nombre_promo: promotion.data_promocion.nombre_promocion,
						precio_lista: component.props.precioLista,// parseInt(document.getElementById("preciolista_"+component.props.id).value),
						precio_promocion: dineroaNumero(document.getElementById("preciopromocion_"+component.props.id).value),
						promotora: 2,
						publicacion: 5,
						pvp: dineroaNumero(document.getElementById("pvp_"+component.props.id).value),
						duracion_sellin: 1,
						duracion_sellout: 1,
						termino_sellin: terminoSellin,
						termino_sellout: terminoSellout,
						exhibicion: getId(document.getElementById("exhibicion_"+component.props.id).value, "exhibicion"),
						tipo_promocion : component.props.tipoPromocion,
						id_estado_promocional: !component.props.estadoPromocional ? estadoPromocion : component.props.estadoPromocional,
						estado_promocional: !component.props.estadoPromocional ? estadoPromocion : component.props.estadoPromocional
						
						// codigo_producto: component.props.id.split("_")[0],
					};
					newColumns.push(newColumn);
				
				
				
			})
			console.log("Columnas nuevas y antiguas a actualizar::::::: ");
			console.log(newColumns); // hasta acá todo bien
			// legendColumnInput (producto-cadena)
			// Tomar copia de data_rows y data init completo.
			const newPromotion =  {...promotion};

			newPromotion.data_rows = [...newColumns];
			
			// Consulta al servicio Web.
			// alert(idPromocion);
			// Filtrar los elementos en data_rows
			newPromotion.data_rows = newPromotion.data_rows.filter((row) => {
				// Verificar si cod_producto no es igual a -1 y no es de tipo 'string'
				if(row) return row.cod_producto !== -1 && typeof row.cod_producto !== 'string';

				return false
			});
			console.log("Enviado Final::::::::::::::::::: ");
			console.log(newPromotion);
			
			if(accionGuardar ){ // || simulacionProcess
				const isStateMoveFlow = ((estadoPromocion === "5" || estadoPromocion === "7") && (
					localStorage.getItem('rol') === 'ADMIN' ||
					localStorage.getItem('rol') === 'SUPER ADMIN' ||
					localStorage.getItem('rol') === 'APROBADOR' 
					)) ||
					(estadoPromocion === "9" && (
						localStorage.getItem('rol') === 'ADMIN' ||
						localStorage.getItem('rol') === 'SUPER ADMIN' ||
						localStorage.getItem('rol') === 'KAM' ||
						localStorage.getItem('rol') === 'KAS' 
						));

				setLoader(true);
				(async () => {
					// Always persist edited columns first.
					try {
						const saveResponse = await savePromotion(idPromocion, newPromotion);
						console.log("Respuesta de guardado de promocion::: ");
						console.log(saveResponse);
						setFlagReloadPromotion(true);
					} catch (error) {
						console.log("Error al guardar promoción::: ");
						console.log(error);
						alert("No fue posible guardar los cambios del catálogo.");
						setLoader(false);
						return;
					}

					// Then try promotional-state update for review flows (without redirect).
					if (isStateMoveFlow) {
						let gestionProductos = [];
						try {
							const rawGestionProductos = localStorage.getItem('gestionProductos');
							gestionProductos = rawGestionProductos ? JSON.parse(rawGestionProductos) : [];
						} catch (error) {
							console.log("Error parseando gestionProductos::: ");
							console.log(error);
							gestionProductos = [];
						}

						// Only call state-update API if there are pending state changes.
						if (Array.isArray(gestionProductos) && gestionProductos.length > 0) {
							try {
								const response = await changeStateMultipleRows();
								console.log("Respuesta de cambio de estado al momento de guardar::: ");
								console.log(response);
								window.location.href = '/HomeNew';
							} catch (error) {
								console.log("Error al cambiar estado promocional de productos::: ");
								console.log(error);
								alert("Los cambios se guardaron, pero no se pudo actualizar el estado promocional.");
							}
						}
					}
					setLoader(false);
				})();
			}

			const hasInvalidAdherenciaForSimulation = hasAdherenciaMayorA100(newPromotion);
			const isPromotionValid = validatePromotion(newPromotion);

			if (simulacionProcess && hasInvalidAdherenciaForSimulation) {
				alert("No se puede simular con adherencias mayores a 100, revisa tu panel");
				setSimulacionProcess(false);
			} else if(isPromotionValid && simulacionProcess){ // Se puede simular
				// alert("Simulando!!!!!!!!!");
				newPromotion.data_rows.forEach((row) => {
					// row.activacion = getId(row.activacion, "activacionValue");
					row.mecanica = getId(row.mecanica, "mecanicaValue");
					row.promotora = "NO";
					row.inicio_sellin = row.inicio_sellin !== "" ? row.inicio_sellin : "2023-10-01";
					row.inicio_sellout = row.inicio_sellout !== "" ? row.inicio_sellout : "2023-10-01";
					row.termino_sellout = row.termino_sellout !== "" ? row.termino_sellout : "2023-10-14";
					row.termino_sellin = row.termino_sellin !== "" ? row.termino_sellin : "2023-10-14";
				});
				try{
					simulatePromotion(newPromotion, idPromocion, estadoPromocion).then((response) => {
						console.log("Respuesta de Simulación Promoción::: ");
						console.log(response);
						// Servicio para mover promoción en caso de que esté setteado.
						// movePromotion(idPromocion, newPromotion);
						// setPromotion(newPromotion);
						// alert(response.status);
						if(response.status === 200){
							setSimulacionData(response);
							console.log(response);
						}else{
							alert("Por favor, completar todos los campos obligatorios. e: 1001 : "+response.message);
							console.log("ERROR 500 U OTRO EN SIMULADOR 1!!!!");
						}
						
						setSimulacionProcess(false)
					}).catch((error) => {
						alert("Por favor, completar todos los campos obligatorios. e: 1002 : "+error);
						console.log("2")
						console.log(error);
						setSimulacionProcess(false)
					});
				}catch(error){
					alert("Por favor, completar todos los campos obligatorios. e: 1003 : "+error);
					console.log("ERROR 500 U OTRO EN SIMULADOR 3!!!!");
					setSimulacionProcess(false)
				}
				
			}else if(!isPromotionValid && simulacionProcess){
				// alert("Por favor, completar todos los campos obligatorios.");
				let errores = "Por favor revisar los siguientes errores marcados en rojo \n";
				textoValidacion.forEach((item) => {
					errores += item+"\n";
				})
				alert(errores);
				setSimulacionProcess(false)
			}

			// setSimulacionProcess(false)
			setAprobarMovimiento(validatePromotion(newPromotion));
			setValidacionProcess(false);
			// Proceso terminado
			// alert("Guardando cambios!!!!");
			setAccionGuardar(false)

			// Formateo de campos a descargar:::::
			const newPromotionDescarga = {...newPromotion};
			newPromotionDescarga.data_rows.forEach((row) => {
				row.inversion_adicional = numeroaDinero(row.inversion_adicional);
				row.margen_cliente = numeroaDescuento(row.margen_cliente);
				row.precio_lista = numeroaDinero(row.precio_lista);
				row.precio_promocion = numeroaDinero(row.precio_promocion);
				row.pvp = numeroaDinero(row.pvp);
				row.descuento = numeroaDescuento(row.descuento);
				row.adherencia = numeroaDescuento(row.adherencia);
				row.mecanica = getId(row.mecanica, "mecanicaValue");
				row.cod_producto = getId(row.cod_producto, "codigo_productoValue");
				row.activacion = getId(row.activacion, "activacionValue");
				row.exhibicion = getId(row.exhibicion, "exhibicionValue");
				row.inicio_sellin = getDateFormat(row.inicio_sellin);
				row.inicio_sellout = getDateFormat(row.inicio_sellout);
				row.termino_sellin = getDateFormat(row.termino_sellin);
				row.termino_sellout = getDateFormat(row.termino_sellout);
				delete row.duracion_sellin;
				delete row.duracion_sellout;
				delete row.promotora;
				delete row.publicacion;
				delete row.id_activacion;
				delete row.id_exhibicion;
				delete row.id_mecanica;
				delete row.id_promotora;
				delete row.id_publicacion;
				delete row.descripcion_producto;
			});
			// setDataDescarga(newPromotionDescarga.data_rows);
			const dataFiltrada = newPromotionDescarga.data_rows.map(row => {
				const { 
					id_estado_promocional: _idEstado, 
					estado_promocional: _estado, 
					cod_producto: _codProducto, 
					...rest 
				  } = row;
				  
				return rest;
			  });
			  
			setDataDescarga(dataFiltrada);
			setFlagReloadPromotion(true);
			  
		}
	}, [legendColumns, accionGuardar, simulacionProcess, validacionProcess])

	const validatePromotion = (promotion) => {
		console.log("PROMOCIONES A VALIDAR:::::::::::");
		console.log(promotion);
		let erroresDescuentos = 0; // mayores a 100 o negativos
		let erroresPrecioPromo = 0;
		let erroresInvadicional = 0;
		let erroresSellin = 0;
		let erroresSellout = 0;
		let erroresAdherencia = 0;
		let erroresMecanica = 0;
		let erroresExhibicion = 0;
		let erroresActivacion = 0;
		let erroresPvp = 0;
		// let erroresMargenCliente = 0;

		promotion.data_rows.forEach((row) => {
			const idCompuesto =  getId(row.cod_producto, "codigo_productoValue")+"_"+promotion.data_promocion.nombre_cadena;
			console.log(idCompuesto+" ::::: NUEVO ID A CATALOGAR");
			console.log(row);
			if(row.mecanica === "" || row.mecanica === null || row.mecanica === -1){
				erroresMecanica++;
				console.log("mecanicaField_"+idCompuesto);
				try{
					document.getElementById("mecanicaField_"+idCompuesto).classList.add("inputError");
				}catch(error){
					console.log("ERROR AL AGREGAR CLASE");
					if(erroresMecanica > 0){
						erroresMecanica--;
					}
				}
			}else{
				try{
					document.getElementById("mecanicaField_"+idCompuesto).classList.remove("inputError");
				}catch(error){
					console.log("ERROR AL QUITAR CLASE ERROR");
					if(erroresMecanica > 0){
						erroresMecanica--;
					}
				}
				// document.getElementById("mecanicaField_"+idCompuesto).classList.remove("inputError");
			}
			if(row.exhibicion === "" || row.exhibicion === null || row.exhibicion === -1){
				erroresExhibicion++;
				try{
					document.getElementById("exhibicionField_"+idCompuesto).classList.add("inputError");
				}catch(error){
					console.log("ERROR AL AGREGAR CLASE");
					if(erroresExhibicion > 0){
						erroresExhibicion--;
					}
				}
			}else{
				try{
					document.getElementById("exhibicionField_"+idCompuesto).classList.remove("inputError");
				}catch(error){
					console.log("ERROR AL QUITAR CLASE ERROR");
					if(erroresExhibicion > 0){
						erroresExhibicion--;
					}
				}
			}
			if(row.activacion === "" || row.activacion === null || row.activacion === -1){
				erroresActivacion++;
				try{
					document.getElementById("activacionField_"+idCompuesto).classList.add("inputError");
				}catch(error){
					console.log("ERROR AL AGREGAR CLASE");
					if(erroresActivacion > 0){
						erroresActivacion--;
					}
				}
			}else{
				try{
					document.getElementById("activacionField_"+idCompuesto).classList.remove("inputError");
				}catch(error){
					console.log("ERROR AL QUITAR CLASE ERROR");
					if(erroresActivacion > 0){
						erroresActivacion--;
					}
				}
			}
			if(row.pvp <= 0 || row.pvp === "" || row.pvp === null){
				erroresPvp++;
				try{
					document.getElementById("pvpField_"+idCompuesto).classList.add("inputError");
				}catch(error){
					console.log("ERROR AL AGREGAR CLASE");
					if(erroresPvp > 0){
						erroresPvp--;
					}
				}
			}else{
				try{
					document.getElementById("pvpField_"+idCompuesto).classList.remove("inputError");
				}catch(error){
					console.log("ERROR AL QUITAR CLASE ERROR");
					if(erroresPvp > 0){
						erroresPvp--;
					}
				}
			}
			if(row.descuento > 100 || row.descuento <= 0 || row.descuento === "" || row.descuento === null){
				erroresDescuentos++;
				try{
					document.getElementById("descuentoField_"+idCompuesto).classList.add("inputError");
				}catch(error){
					console.log("ERROR AL AGREGAR CLASE");
					if(erroresDescuentos > 0){
						erroresDescuentos--;
					}
				}
			}else{
				try{
					document.getElementById("descuentoField_"+idCompuesto).classList.remove("inputError");
				}catch(error){
					console.log("ERROR AL QUITAR CLASE ERROR");
					if(erroresDescuentos > 0){
						erroresDescuentos--;
					}
				}
			}
			if(row.tipo_promocion === 'SELL-IN' && (row.precio_promocion < 0 || row.precio_promocion > row.precio_lista || row.precio_promocion === "" || row.precio_promocion === null)){
				erroresPrecioPromo++;
				try{
					document.getElementById("preciopromocionField_"+idCompuesto).classList.add("inputError");
				}catch(error){
					console.log("ERROR AL AGREGAR CLASE");
					if(erroresPrecioPromo > 0){
						erroresPrecioPromo--;
					}
				}
			}else{
				try{
					document.getElementById("preciopromocionField_"+idCompuesto).classList.remove("inputError");
				}catch(error){
					console.log("ERROR AL QUITAR CLASE ERROR");
					if(erroresPrecioPromo > 0){
						erroresPrecioPromo--;
					}
				}
			}
			if(row.inversion_adicional < 0 || row.inversion_adicional === "" || row.inversion_adicional === null){
				erroresInvadicional++;
				try{
					document.getElementById("invadicionalField_"+idCompuesto).classList.add("inputError");
				}catch(error){
					console.log("ERROR AL AGREGAR CLASE");
					if(erroresInvadicional > 0){
						erroresInvadicional--;
					}
				}
			}else{
				try{
					document.getElementById("invadicionalField_"+idCompuesto).classList.remove("inputError");
				}catch(error){
					console.log("ERROR AL QUITAR CLASE ERROR");
					if(erroresInvadicional > 0){
						erroresInvadicional--;
					}
				}
			}
			if(row.tipo_promocion === 'SELL-IN'){
				if((row.inicio_sellout < row.inicio_sellin) || (row.inicio_sellout > row.termino_sellin) || (row.inicio_sellout > row.termino_sellout) || (row.inicio_sellout === "" || row.inicio_sellout === null)){
					erroresSellin++;
					try{
						document.getElementById("IngresoPromocionDropDownDate_"+idCompuesto+"_sellin").classList.add("inputError");
						document.getElementById("IngresoPromocionDropDownDate_"+idCompuesto+"_sellout").classList.add("inputError");
					}catch(error){
						console.log("ERROR AL AGREGAR CLASE");
						if(erroresSellin > 0){
							erroresSellin--;
						}
					}
				}else{
					try{
						document.getElementById("IngresoPromocionDropDownDate_"+idCompuesto+"_sellin").classList.remove("inputError");
						document.getElementById("IngresoPromocionDropDownDate_"+idCompuesto+"_sellout").classList.remove("inputError");
					}catch(error){
						console.log("ERROR AL QUITAR CLASE ERROR");
						if(erroresSellin > 0){
							erroresSellin--;
						}
					}
				}
			}
			if((row.termino_sellout < row.inicio_sellout) || (row.termino_sellout === "" || row.termino_sellout === null) || (row.inicio_sellout === "" || row.inicio_selloout === null) 
			|| (row.termino_sellin < row.termino_sellout)){
				erroresSellout++;
				// document.getElementById("IngresoPromocionDropDownDate_"+idCompuesto+"_sellin").classList.add("inputError");
				try{
					document.getElementById("IngresoPromocionDropDownDate_"+idCompuesto+"_sellout").classList.add("inputError");
				}catch(error){
					console.log("ERROR AL AGREGAR CLASE");
					if(erroresSellout > 0){
						erroresSellout--;
					}
				}
			}else{
				try{
					document.getElementById("IngresoPromocionDropDownDate_"+idCompuesto+"_sellout").classList.remove("inputError");
				}catch(error){
					console.log("ERROR AL QUITAR CLASE ERROR");
					if(erroresSellout > 0){
						erroresSellout--;
					}
				}
			}
			if(row.adherencia > 100 || row.adherencia < 0 || row.adherencia === "" || row.adherencia === null){
				erroresAdherencia++;
				try{
					document.getElementById("adherenciaField_"+idCompuesto).classList.add("inputError");
				}catch(error){
					console.log("ERROR AL AGREGAR CLASE");
					if(erroresAdherencia > 0){
						erroresAdherencia--;
					}
				}
			}else{
				try{
					document.getElementById("adherenciaField_"+idCompuesto).classList.remove("inputError");
				}catch(error){
					console.log("ERROR AL QUITAR CLASE ERROR");
					if(erroresAdherencia > 0){
						erroresAdherencia--;
					}
				}
			}
		});
		const mensajesError = [];
		if(erroresDescuentos > 0){ mensajesError.push(erroresDescuentos+ ' Errores en Descuento');}
		if(erroresPrecioPromo > 0){ mensajesError.push(erroresPrecioPromo+ ' Errores en Precio Promo ');}
		if(erroresInvadicional > 0){ mensajesError.push(erroresInvadicional+ ' Errores en Inversion Adicional');}
		if(erroresSellin > 0){ mensajesError.push(erroresSellin+ ' Errores en Sellin');}
		if(erroresSellout > 0){ mensajesError.push(erroresSellout+ ' Errores en Sellout');}
		if(erroresAdherencia > 0){ mensajesError.push(erroresAdherencia+ ' Errores en Adherencia');}
		if(erroresMecanica > 0){ mensajesError.push(erroresMecanica+ ' Errores en Mecanica');}
		if(erroresExhibicion > 0){ mensajesError.push(erroresExhibicion+ ' Errores en Exhibicion');}
		if(erroresActivacion > 0){ mensajesError.push(erroresActivacion+ ' Errores en Activacion');}
		if(erroresPvp > 0){ mensajesError.push(erroresPvp+ ' Errores en PVP');}
		if(promotion.data_rows.length === 0){ mensajesError.push('No hay productos en la promoción');}

		const errorCatalogoVacio = promotion.data_rows.length === 0 ? 1 : 0;

		const erroresTotales = erroresDescuentos + erroresPrecioPromo + erroresInvadicional + erroresSellin + erroresSellout + erroresAdherencia + erroresMecanica + erroresExhibicion + erroresActivacion + erroresPvp + errorCatalogoVacio;
		if(erroresTotales > 0){
			setValidacion(true);
			setTextoValidacion(mensajesError);
		}else{
			setValidacion(false);
			setTextoValidacion([]);
		}
		console.log("ERRORES TOTALES VALIDACION ENCONTRADOS::::: "+erroresTotales);
		return !(erroresTotales > 0);
	}

	// Cambio de fechas a todo el catálogo :::

	useEffect(() => {
		if(inicioCambio && terminoCambio && accionCambiarFecha){
			console.log("Actualizando....")
			const inicioCambioFormat = getDateFormat(inicioCambio);
			const terminoCambioFormat = getDateFormat(terminoCambio);
			
			setLegendColumns(prevLegendColumns => {
				// Verificamos si prevLegendColumns es un array
				// alert("actualizadon "+inicioCambioFormat+" - "+terminoCambioFormat)
				if (Array.isArray(prevLegendColumns)) {
					// Mapeamos las columnas y asignamos los nuevos valores
					if(tipoBotonPromotion === "sell_in"){
						return prevLegendColumns.map(column => ({
							...column,
							props: {
								...column.props,
								inicioSellin: inicioCambioFormat , // Asignar el nuevo valor
								terminoSellin: terminoCambioFormat
							}
						}));
					}else{
						return prevLegendColumns.map(column => ({
							...column,
							props: {
								...column.props,
								inicioSellout: inicioCambioFormat,
								terminoSellout: terminoCambioFormat
							}
						}));
					}
					
				} else {
					// En caso de que prevLegendColumns no sea un array, podrías manejarlo según tu lógica
					return []; // o maneja el caso que prefieras
				}
			});
			// setInicioCambio(null);
			// setTerminoCambio(null);
			setAccionCambiarFecha(false)
		}
	}, [inicioCambio, terminoCambio, accionCambiarFecha]);

	useEffect(() => {
		if (!valorMecanicaCambio || !accionCambiarMecanica) {
			return;
		}

		const targetPromotionType =
			tipoBotonMecanica === 'sell_in' ? 'SELL-IN' : 'SELL-OUT';

		setLegendColumns((prevLegendColumns) => {
			if (!Array.isArray(prevLegendColumns)) {
				return [];
			}

			return prevLegendColumns.map((column) => {
				if (column.props.tipoPromocion !== targetPromotionType) {
					return column;
				}

				const updates = {
					mecanica: valorMecanicaCambio,
				};

				if (String(valorMecanicaCambio).toUpperCase() === '1XY') {
					updates.adherencia = '100,00';
				}

				return {
					...column,
					props: {
						...column.props,
						...updates,
					},
				};
			});
		});

		setAccionCambiarMecanica(false);
		setValorMecanicaCambio(null);
		setMecanicaCambiar(false);
	}, [valorMecanicaCambio, accionCambiarMecanica, tipoBotonMecanica]);

	useEffect(() => {
		if (!valorCampoMasivo || !accionCambiarCampoMasivo || !campoMasivoTipo) {
			return;
		}

		const targetPromotionType =
			tipoBotonCampoMasivo === 'sell_in' ? 'SELL-IN' : 'SELL-OUT';

		setLegendColumns((prevLegendColumns) => {
			if (!Array.isArray(prevLegendColumns)) {
				return [];
			}

			return prevLegendColumns.map((column) => {
				if (column.props.tipoPromocion !== targetPromotionType) {
					return column;
				}

				const nextProps = {...column.props};

				if (campoMasivoTipo === 'adherencia') {
					nextProps.adherencia =
						String(column.props.mecanica).toUpperCase() === '1XY'
							? '100,00'
							: numeroaDescuento(descuentoaNumero(valorCampoMasivo));
				}

				if (campoMasivoTipo === 'exhibicion') {
					nextProps.exhibicion = Number(valorCampoMasivo);
				}

				if (campoMasivoTipo === 'activacion') {
					nextProps.activacion = valorCampoMasivo;
				}

				if (campoMasivoTipo === 'invAdicional') {
					nextProps.invAdicional = dineroaNumero(valorCampoMasivo);
				}

				if (campoMasivoTipo === 'mgCliente') {
					const mgClienteValue = descuentoaNumero(valorCampoMasivo);
					const parsedMgCliente = Number.isFinite(mgClienteValue) ? mgClienteValue : 0;
					const factor = parseFloat(column.props.product?.factor);
					const isKgProduct =
						String(column.props.product?.um).toUpperCase() === 'KG' &&
						Number.isFinite(factor);
					const precioPromocionBase =
						targetPromotionType === 'SELL-IN'
							? parseFloat(column.props.precioPromocion)
							: parseFloat(column.props.precioLista);
					const validPrecioBase = Number.isFinite(precioPromocionBase)
						? precioPromocionBase
						: 0;
					const denominator = 1 - parsedMgCliente / 100;
					let pvpCalculado = 0;

					if (denominator !== 0) {
						if (targetPromotionType === 'SELL-IN') {
							pvpCalculado = isKgProduct
								? Math.round((validPrecioBase * factor * 1.19) / denominator)
								: Math.round((validPrecioBase * 1.19) / denominator);
						} else {
							const precioFleje = isKgProduct
								? Math.round((validPrecioBase * factor * 1.19) / denominator)
								: Math.round((validPrecioBase * 1.19) / denominator);
							const descuentoActual = descuentoaNumero(column.props.descuento);
							const parsedDescuento = Number.isFinite(descuentoActual)
								? descuentoActual
								: 0;
							nextProps.precioPromocion = precioFleje;
							pvpCalculado = Math.round(precioFleje * (1 - parsedDescuento / 100));
						}
					}

					nextProps.mgCliente = parsedMgCliente;
					nextProps.pvp = pvpCalculado;
				}

				if (campoMasivoTipo === 'precioPromocion') {
					const precioPromocionValue = dineroaNumero(valorCampoMasivo);
					const parsedPrecioPromocion = Number.isFinite(precioPromocionValue)
						? precioPromocionValue
						: 0;
					const factor = parseFloat(column.props.product?.factor);
					const isKgProduct =
						String(column.props.product?.um).toUpperCase() === 'KG' &&
						Number.isFinite(factor);

					if (targetPromotionType === 'SELL-IN') {
						const precioLista = parseFloat(column.props.precioLista);
						const parsedPrecioLista = Number.isFinite(precioLista) ? precioLista : 0;
						const descuentoCalculado =
							parsedPrecioLista > 0
								? parseFloat((1 - parsedPrecioPromocion / parsedPrecioLista) * 100).toFixed(2)
								: 0;
						const mgClienteActual = descuentoaNumero(column.props.mgCliente);
						const parsedMgCliente = Number.isFinite(mgClienteActual)
							? mgClienteActual
							: 0;
						const denominator = 1 - parsedMgCliente / 100;
						let pvpCalculado = 0;

						if (denominator !== 0) {
							pvpCalculado = isKgProduct
								? Math.round((parsedPrecioPromocion * factor * 1.19) / denominator)
								: Math.round((parsedPrecioPromocion * 1.19) / denominator);
						}

						nextProps.precioPromocion = parsedPrecioPromocion;
						nextProps.descuento = descuentoCalculado;
						nextProps.pvp = pvpCalculado;
					} else {
						const precioLista = parseFloat(column.props.precioLista);
						const parsedPrecioLista = Number.isFinite(precioLista) ? precioLista : 0;
						const baseCosto = isKgProduct
							? parsedPrecioLista * factor * 1.19
							: parsedPrecioLista * 1.19;
						let mgClienteCalculado = 0;

						if (parsedPrecioPromocion > 0) {
							mgClienteCalculado = parseFloat(
								(1 - baseCosto / parsedPrecioPromocion) * 100
							).toFixed(2);
						}

						const descuentoActual = descuentoaNumero(column.props.descuento);
						const parsedDescuento = Number.isFinite(descuentoActual)
							? descuentoActual
							: 0;
						const pvpCalculado = Math.round(
							parsedPrecioPromocion * (1 - parsedDescuento / 100)
						);

						nextProps.precioPromocion = parsedPrecioPromocion;
						nextProps.mgCliente = mgClienteCalculado;
						nextProps.pvp = pvpCalculado;
					}
				}

				if (campoMasivoTipo === 'descuento') {
					const descuentoValue = descuentoaNumero(valorCampoMasivo);
					const parsedDescuento = Number.isFinite(descuentoValue)
						? descuentoValue
						: 0;
					const factor = parseFloat(column.props.product?.factor);
					const isKgProduct =
						String(column.props.product?.um).toUpperCase() === 'KG' &&
						Number.isFinite(factor);

					if (targetPromotionType === 'SELL-IN') {
						const precioLista = parseFloat(column.props.precioLista);
						const parsedPrecioLista = Number.isFinite(precioLista) ? precioLista : 0;
						const precioPromocionCalculado = Math.round(
							parsedPrecioLista * (1 - parsedDescuento / 100)
						);
						const mgClienteActual = descuentoaNumero(column.props.mgCliente);
						const parsedMgCliente = Number.isFinite(mgClienteActual)
							? mgClienteActual
							: 0;
						const denominator = 1 - parsedMgCliente / 100;
						let pvpCalculado = 0;

						if (denominator !== 0) {
							pvpCalculado = isKgProduct
								? Math.round((precioPromocionCalculado * factor * 1.19) / denominator)
								: Math.round((precioPromocionCalculado * 1.19) / denominator);
						}

						nextProps.precioPromocion = precioPromocionCalculado;
						nextProps.descuento = parsedDescuento;
						nextProps.pvp = pvpCalculado;
					} else {
						const mgClienteActual = descuentoaNumero(column.props.mgCliente);
						const parsedMgCliente = Number.isFinite(mgClienteActual)
							? mgClienteActual
							: 0;
						const precioLista = parseFloat(column.props.precioLista);
						const parsedPrecioLista = Number.isFinite(precioLista) ? precioLista : 0;
						const denominator = 1 - parsedMgCliente / 100;
						let precioFleje = 0;

						if (denominator !== 0) {
							precioFleje = isKgProduct
								? Math.round((parsedPrecioLista * factor * 1.19) / denominator)
								: Math.round((parsedPrecioLista * 1.19) / denominator);
						}

						const pvpCalculado = Math.round(
							precioFleje * (1 - parsedDescuento / 100)
						);

						nextProps.precioPromocion = precioFleje;
						nextProps.descuento = parsedDescuento;
						nextProps.pvp = pvpCalculado;
					}
				}

				return {
					...column,
					props: nextProps,
				};
			});
		});

		setAccionCambiarCampoMasivo(false);
		setValorCampoMasivo(null);
		setCampoMasivoCambiar(false);
	}, [
		valorCampoMasivo,
		accionCambiarCampoMasivo,
		campoMasivoTipo,
		tipoBotonCampoMasivo,
	]);

	return (
		<>
		{ (promotion && modalProduct && dataProduct) &&
			<CodigoPopNew
			// setCodigoPop,
				dataProduct = {dataProduct}
				setDataProduct = {setDataProduct}
				setCodigoPop = {setModalProduct}
				idPromocion = {idPromocion}
				promotion = {promotion}
				saveCatalogBeforeComment={saveCatalogBeforeProductComment}
				tradicional = {false}
			/>
		}
		{rejectReasonProduct && (
			<RechazoProductoModal
				product={rejectReasonProduct}
				idPromocion={idPromocion}
				setRejectReasonProduct={setRejectReasonProduct}
				saveCatalogBeforeComment={saveCatalogBeforeProductComment}
			/>
		)}
		{loader && <LoaderNew notdo={true}/>}
		
		<div className='HomeNew'>
			{ 
				// validacion && <InicioPopValidacion setValidacion={setValidacion} texto={textoValidacion}/>
			}
			{dataDescarga && (<CSVLink
				data={dataDescarga}
				filename={'download.csv'}
				className={"csv-link"}
				ref={csvLinkRef} // Asigna la referencia al CSVLink
			>
				Descargar CSV
			</CSVLink>)}
			{LogoutState && <LogoutPopup setLogoutState={setLogoutState} />}
			{InicioPopState && <InicioPopEliminar 
			setInicioPopState={setInicioPopState} 
			idProducto={idEliminar}
			setIdProductoEliminar={setIdProductoEliminar}
			/>}

			{cargaMasiva && <CargaMasiva setCargaMasiva={setCargaMasiva}
				typePromotion={typePromotion}
				idPromocion={idPromocion}
				promotion={promotion}
			/>}

			{fechasCambiar && <SetFechas setFechasCambiar={setFechasCambiar}
				setInicioCambio={setInicioCambio}
				setTerminoCambio={setTerminoCambio}
				setAccionCambiarFecha={setAccionCambiarFecha}
				typePromotion={typePromotion}
				tipoBotonPromotion={tipoBotonPromotion}
			/>}

			{mecanicaCambiar && (
				<SetMecanica
					setMecanicaCambiar={setMecanicaCambiar}
					setValorMecanicaCambio={setValorMecanicaCambio}
					setAccionCambiarMecanica={setAccionCambiarMecanica}
					tipoBotonMecanica={tipoBotonMecanica}
					mecanicas={
						promotion?.mecanicas?.map((item) => item.mecanica).filter(Boolean) || []
					}
				/>
			)}

			{campoMasivoCambiar && (
				<SetCampoMasivo
					setCampoMasivoCambiar={setCampoMasivoCambiar}
					setValorCampoMasivo={setValorCampoMasivo}
					setAccionCambiarCampoMasivo={setAccionCambiarCampoMasivo}
					tipoBotonCampoMasivo={tipoBotonCampoMasivo}
					campoMasivoTipo={campoMasivoTipo}
					opciones={
						campoMasivoTipo === 'exhibicion'
							? promotion?.exhibiciones?.map((item) => ({
									value: item.id,
									label: item.exhibicion,
								})) || []
							: campoMasivoTipo === 'activacion'
							? promotion?.activaciones?.map((item) => ({
									value: item.activacion,
									label: item.activacion,
								})) || []
							: []
					}
				/>
			)}
			
			<Header setLogoutState={setLogoutState} />

			{/* header done */}
			{(promotion && simulacionData) && <IngresoPromocionHeader nroSku={
				legendColumns && legendColumns.length
			}
			promotion={promotion}
			setSimulacionProcess={setSimulacionProcess}
			simulacionProcess={simulacionProcess}
			Spinner={Spinner}
			simulacionData={simulacionData}
			viewPage={viewPage}
			typePromotion={typePromotion}
			canUseBulkProductDecision={getProductDecisionConfig().canUseDecisionActions}
			bulkRejectLabel={getProductDecisionConfig().rejectLabel}
			onBulkApprovePending={() => handleBulkProductDecision('aprobado')}
			onBulkRejectPending={() => handleBulkProductDecision('rechazado')}
			/>
			}

			<div
				className={`body-area-ingreso ${simulacionPage ? 'body-area-ingreso-resumen' : 'body-area-ingreso-promocion'} ${catalogViewMode === 'table' ? 'body-area-ingreso-table' : ''}`}
				style={{height: `${HeightState}px`}}
			>
				{( promotion && !simulacionPage && catalogViewMode !== 'table') &&
				<LengendColumns tipoPromocion={typePromotion}
				setFechasCambiar={setFechasCambiar}
				toolTips={promotion.texto_tooltips}
				setTipoBotonPromotion={setTipoBotonPromotion}
				setMecanicaCambiar={setMecanicaCambiar}
				setTipoBotonMecanica={setTipoBotonMecanica}
				setCampoMasivoCambiar={setCampoMasivoCambiar}
				setTipoBotonCampoMasivo={setTipoBotonCampoMasivo}
				setCampoMasivoTipo={setCampoMasivoTipo}
				/>
				}
	{ // !simulacionPage &&
				<div className={`columns-area-wrapper ${catalogViewMode === 'table' ? `promotion-table-area ${typePromotion === 'SELL-IN' ? 'sell-in' : 'sell-out'}` : ''} ${simulacionPage ? 'hiddenV2' : ''}`} >
					<div
						className={`column-track columnTracking ${catalogViewMode === 'table' ? 'column-track-table' : ''}`}
						style={{// transform: `translateX(-${TransformState}px)`,
						overflowX: catalogViewMode === 'table' ? "auto" : "scroll",
						marginRight: "80px",
						scrollbarWidth: "thin",
						scrollbarColor: "transparent transparent gray",
						scrollBehavior: "smooth",
						width: "96%",
						overflowY: catalogViewMode === 'table' ? "auto" : "hidden"
					}}
						id={"column-track"}
					>
						{catalogViewMode === 'table' && !simulacionPage && (
							<div className='promotion-table-header'>
								{getTableHeaders().map((header) => (
									<div
										key={header.label}
										className={`promotion-table-header-cell ${header.onClick ? 'clickable' : ''}`}
									>
										{header.onClick ? (
											<button type='button' onClick={header.onClick}>
												{header.label}
											</button>
										) : (
											header.label
										)}
									</div>
								))}
							</div>
						)}
					
						
						{(legendColumns && !viewPage) && // Muestra de columnas formularios
							legendColumns.length > 0 && 
								legendColumns.map((component, index) => renderLegendColumnComponent(component, index))
						}

						{legendColumns && viewPage &&
						legendColumns.length > 0 &&
						legendColumns
							.map((component, index) => renderLegendColumnComponent(component, index))
						}
						
					</div>

					<div className='buttons-wrapper'>
						<button
							className='prev'
							onClick={(e) => {
								
								document.getElementById("column-track").scrollLeft -= 100;
							}}
						>
							<svg
								width='28'
								height='28'
								viewBox='0 0 28 28'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<rect width='28' height='28' rx='4' fill='#DBE7FF' />
								<g clipPath='url(#clip0_655_479170)'>
									<mask
										id='mask0_655_479170'
										maskUnits='userSpaceOnUse'
										x='8'
										y='8'
										width='12'
										height='12'
									>
										<rect x='8' y='8' width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_655_479170)'>
										<path
											d='M15.375 18.5375L11.1625 14.3375C11.1042 14.2792 11.0625 14.2167 11.0375 14.15C11.0125 14.0833 11 14.0125 11 13.9375C11 13.8625 11.0125 13.7917 11.0375 13.725C11.0625 13.6583 11.1042 13.5958 11.1625 13.5375L15.375 9.325C15.5083 9.19167 15.6708 9.125 15.8625 9.125C16.0542 9.125 16.2167 9.19583 16.35 9.3375C16.4917 9.47083 16.5625 9.63117 16.5625 9.8185C16.5625 10.0062 16.4917 10.1708 16.35 10.3125L12.725 13.9375L16.35 17.5625C16.4833 17.6958 16.55 17.8562 16.55 18.0435C16.55 18.2312 16.4833 18.3958 16.35 18.5375C16.2083 18.6708 16.0438 18.7375 15.8565 18.7375C15.6688 18.7375 15.5083 18.6708 15.375 18.5375Z'
											fill='#124FC9'
										/>
									</g>
								</g>
								<defs>
									<clipPath id='clip0_655_479170'>
										<rect
											width='12'
											height='12'
											fill='white'
											transform='translate(8 8)'
										/>
									</clipPath>
								</defs>
							</svg>
						</button>
						<button
							className='forward'
							onClick={(e) => {
								
								document.getElementById("column-track").scrollLeft += 100;
								
							}}
						>
							<svg
								width='28'
								height='28'
								viewBox='0 0 28 28'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<rect width='28' height='28' rx='4' fill='#DBE7FF' />
								<g clipPath='url(#clip0_655_479176)'>
									<mask
										id='mask0_655_479176'
										maskUnits='userSpaceOnUse'
										x='8'
										y='8'
										width='12'
										height='12'
									>
										<rect x='8' y='8' width='12' height='12' fill='#D9D9D9' />
									</mask>
									<g mask='url(#mask0_655_479176)'>
										<path
											d='M11.5249 18.6C11.3915 18.4583 11.3249 18.2937 11.3249 18.106C11.3249 17.9187 11.3915 17.7542 11.5249 17.6125L15.1374 14L11.5124 10.375C11.379 10.2417 11.3124 10.0792 11.3124 9.8875C11.3124 9.69583 11.3832 9.52917 11.5249 9.3875C11.6582 9.25417 11.8207 9.1875 12.0124 9.1875C12.204 9.1875 12.3707 9.25417 12.5124 9.3875L16.7124 13.6C16.7707 13.6583 16.8124 13.7208 16.8374 13.7875C16.8624 13.8542 16.8749 13.925 16.8749 14C16.8749 14.075 16.8624 14.1458 16.8374 14.2125C16.8124 14.2792 16.7707 14.3417 16.7124 14.4L12.4999 18.6125C12.3665 18.7458 12.206 18.8125 12.0184 18.8125C11.831 18.8125 11.6665 18.7417 11.5249 18.6Z'
											fill='#124FC9'
										/>
									</g>
								</g>
								<defs>
									<clipPath id='clip0_655_479176'>
										<rect
											width='12'
											height='12'
											fill='white'
											transform='translate(8 8)'
										/>
									</clipPath>
								</defs>
							</svg>
						</button>
					</div>
				</div>
		}
		{(simulacionPage && simulacionData) &&
			(	!simulacionProcess ?
					<Simulacion simulacionData={simulacionData} simulacionPage={simulacionPage}
						viewPage={viewPage}
						setModalProduct={setModalProduct} setDataProduct={setDataProduct}
						setRejectReasonProduct={setRejectReasonProduct}
					/> : <><h5
					><br></br>Cargando Simulación ...<Spinner/>
					</h5></>
			)
		}

				{promotion &&	
				<LegendColumnRight HeightStateRight={HeightStateRight} 
				setLegendColumns={setLegendColumns}
				legendColumns={legendColumns}
				promotion={promotion}
				setIdProductoEliminar={setIdProductoEliminar}
				setAccionGuardar={setAccionGuardar}
				movimientos={promotion.movimientos}
				setInicioPopStateEliminar={setInicioPopState}
				setIdEliminar={setIdEliminar}
				textoValidacion={textoValidacion}
				aprobarMovimiento={aprobarMovimiento}
				validacion={validacion}
				setSimulacionPage={setSimulacionPage}
				toggleSimulacionPage={toggleSimulacionPage}
				simulacionPage={simulacionPage}
				csvLinkRef={csvLinkRef}
				setTypePromotion={setTypePromotion}
				typePromotion={typePromotion}
				setCargaMasiva={setCargaMasiva}
				setModalProduct={setModalProduct}
				setDataProduct={setDataProduct}
				setRejectReasonProduct={setRejectReasonProduct}
				setFechasCambiar={setFechasCambiar}
				setChangeColumn={setChangeColumn}
				viewPage={viewPage}
				catalogViewMode={catalogViewMode}
				setCatalogViewMode={setCatalogViewMode}
				/>
				}
			</div>
		</div>
		
		</>
	)
}
